export const SET_END_RESULTS = "SET_END_RESULTS";
export const UPDATE_DECISION_ANNOUNCEMENT_RESULTS = "UPDATE_DECISION_ANNOUNCEMENT_RESULTS";
export const UPDATE_WIND_RESULTS = "UPDATE_WIND_RESULTS";
export const UPDATE_SURGE_RESULTS = "UPDATE_SURGE_RESULTS";
export const UPDATE_DECISION_STORM_RESULTS = "UPDATE_DECISION_STORM_RESULTS";
